import {FC} from 'react';
import {FormField} from 'ui';
import {TextInput} from '../components/TextInput';
import type {ResolvedForeignDocumentFieldControl} from './resolveForeignDocumentFieldControl';
import styles from './ForeignDocumentDetailsStep.module.css';

type Props = Omit<ResolvedForeignDocumentFieldControl, 'normalize' | 'clearValue'> & {
	label: string;
	error?: string | null;
	onValueChange: (raw: string) => void;
	onClear: () => void;
};

/** Общий layout поля иностранного документа: FormField + TextInput (+ опциональный префикс). */
export const ForeignDocumentFieldControl: FC<Props> = ({
	label,
	error,
	name,
	value,
	placeholder,
	onValueChange,
	onClear,
	inputMode,
	maxLength,
	multiline,
	autoComplete = 'off',
	prefix,
	ariaLabel,
}) => {
	const input = (
		<TextInput
			name={name}
			value={value}
			placeholder={placeholder}
			inputMode={inputMode}
			maxLength={maxLength}
			multiline={multiline}
			autoComplete={autoComplete}
			aria-label={ariaLabel}
			aria-invalid={error ? true : undefined}
			onChange={(event) => onValueChange(event.target.value)}
			onClear={onClear}
		/>
	);

	return (
		<FormField label={label} error={error}>
			{prefix ? (
				<div className={styles.prefixedInput}>
					<span className={styles.prefix} aria-hidden>
						{prefix}
					</span>
					{input}
				</div>
			) : (
				input
			)}
		</FormField>
	);
};
